import {Component, Inject, OnInit} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';

@Component({
  selector: 'app-notification-toast',
  templateUrl: './notification-toast.component.html',
  styleUrls: ['./notification-toast.component.scss']
})
export class NotificationToastComponent implements OnInit {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,
              public snackBarRef: MatSnackBarRef<NotificationToastComponent>) { }

  notifType: 'error' | 'success' | 'warn' | 'info' = this.data.notificationType;

  ngOnInit(): void {
  }

  getMatIcon() {
    switch (this.notifType) {
      case 'success':
        return "check_circle";
      case 'error':
        return "feedback";
      case 'info':
        return "info";
      case 'warn':
        return "report_problem";
    }
  }

  getMessage(): string {
    return this.data.message;
  }

  getClasses(): string[] {
    return ["snackbar-" + this.notifType];
  }

  getNotificationHeader() {
    switch (this.notifType) {
      case 'success':
        return "Notificación Exitosa";
      case 'error':
        return "Error";
      case 'info':
        return "Notificación";
      case 'warn':
        return "Alerta";
    }
  }
}
